<template>
  <span class="design-preview" aria-hidden="true">
    <i class="dp-spine"></i>
    <i v-for="row in 3" :key="row" :class="['dp-row', row % 2 ? '' : 'dp-row-flipped']">
      <b class="dp-photo"></b><b class="dp-pill"></b>
    </i>
  </span>
</template>

<script>
// The poster design's thumbnail in the ride-settings picker: a zig-zag timeline.
export default {
  name: 'PosterPreview',
};
</script>

<style scoped>
.design-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  height: 92px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #f4f3f0;
  overflow: hidden;
  direction: ltr;
}

.design-preview i,
.design-preview b {
  display: block;
  font-style: normal;
}

.dp-spine {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 50%;
  width: 2px;
  background: #b9b8b4;
}

.dp-row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50%;
  margin-left: 12%;
}

.dp-row-flipped {
  flex-direction: row-reverse;
  margin-left: 38%;
}

.dp-photo {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8ec5fc, #e0c3fc);
}

.dp-pill {
  width: 34px;
  height: 9px;
  margin: 0 4px;
  background: var(--primary-background, #ef6f5c);
}
</style>
